import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { Segno, Soggetto } from '@ideapa/common-utils';

export const ENTITY = 'modello-contabile-riga';

export const ENTITY_PLURAL = 'Righe Modello';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Prospetto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.prospetto.descrizione',
  },
  // {
  //   elementLabel: 'Descrizione Struttura',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'strutturaProspetto.descrizione',
  // },
  // {
  //   elementLabel: 'Lettera',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'strutturaProspetto.lettera',
  // },
  // {
  //   elementLabel: 'Rif 1',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'strutturaProspetto.rif1',
  // },
  // {
  //   elementLabel: 'Rif 2',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'strutturaProspetto.rif2',
  // },
  // {
  //   elementLabel: 'Rif 3',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'strutturaProspetto.rif3',
  // },
  {
    elementLabel: 'Descrizione Struttura',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'strutturaProspetto.descrizioneJoined'
  },
  {
    elementLabel: 'Segno',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    elementValues: Segno,
    field: 'segno',
  },
  {
    elementLabel: 'Soggetto',
    filterType: FilterType.enum,
    fieldType: FieldType.enum,
    elementValues: Soggetto,
    field: 'soggetto',
  },
  {
    elementLabel: 'Ente',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swCapogruppo',
  },
];

export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
